import React from 'react';
import { KFLLayout } from '@kamstrup/kamstrup-frontend-library';
import TopHeader from '../layout/topheader';
import Menu from '../layout/menu';
import { AppKeys } from '../../core/localization';
import Translate from '../shared/localization/localize';

const UnauthorizedPage: React.FC = () => {
  const content = (
    <div className="layout__content__withmargins">
      <p>
        <Translate message={AppKeys.unauthorized_desc} />
      </p>
    </div>
  );
  return (
    <KFLLayout
      topbar={<TopHeader />}
      content={content}
      menu={<Menu title={AppKeys.unauthorized_title} />}
      isSidebarDisabled={false}
    />
  );
};

export default UnauthorizedPage;
